/* eslint-disable lines-between-class-members */
import BaseModel from '@kakadu-dev/base-frontend-helpers/models/BaseModel';
import { Customer } from "./Customer";
/**
 * Customer notification model
 */

export class CustomerNotification extends BaseModel {
  constructor(...args) {
    super(...args);

    this.getId = () => {
      return Number(this.model.id);
    };

    this.getCustomerId = () => {
      return Number(this.model.customerId);
    };

    this.getMessage = () => {
      return this.model.message;
    };

    this.isNew = () => {
      return Boolean(this.model.isNew);
    };

    this.getCreatedAt = () => {
      return this.model.createdAt;
    };

    this.getCustomer = customer => {
      return this.getRelation('customer', Customer, customer);
    };
  }

  /**
   * Create customer notification
   *
   * @param {object} object
   *
   * @return {CustomerNotification}
   */
  static create(object) {
    return super.create(object);
  }
  /**
   * Create list notifications
   *
   * @param {object} objects
   *
   * @return {Array.<CustomerNotification>}
   */


  static createList(objects) {
    return super.createList(objects);
  }
  /**
   * Map notifications
   *
   * @param {Array.<object>} objects
   * @param {function(CustomerNotification): undefined} callback
   *
   * @return {Array.<object>}
   */


  static map(objects, callback) {
    return super.map(objects, callback);
  }
  /**
   * Get model id
   *
   * @return {number}
   */


}